module.exports = __webpack_public_path__ + "img/expostyle_5033_gold_pantone_160946tpx.39735b4e.jpg";